/*
  „Oferte pentru coșul tău” (snippets/tuju-cart-offers.liquid) și linia „Aplică ACASA30” (tuju-cart-code-line).

  - „+ Adaugă” pune produsul în coș prin /cart/add.js; pe rândurile ACASA30 aplică și codul (fără să plece din coș).
  - „Aplică” aplică ACASA30: întâi /discount/ACASA30 (ca linkurile de campanie), verificat în /cart.js; dacă nu
    s-a aplicat, /cart/update.js cu codurile existente + ACASA30.
  - După orice schimbare, coșul lateral se re-randează cu no-store: liniile, titlul, subtotalul, reducerile din
    subsol și blocul de oferte. Tema nu poate fi anunțată direct (emitterul e închis în theme.js), iar XHR-urile ei
    pot primi secțiunea coșului din cache-ul browserului (ETag page_cache) → coș vechi până la refresh.
  - Se păstrează poziția de derulare, focusul revine pe butonul din același loc, subtotalul se evidențiază scurt.
  - dataLayer: cart_offer_add, cart_code_apply, cart_offer_error.
*/
(function () {
  if (window.__tujuCartOffers) return;
  window.__tujuCartOffers = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  function money(cents) {
    var s = (Math.max(0, cents) / 100).toFixed(2).split('.');
    return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1] + ' lei';
  }
  function push(data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }
  function cartBase() {
    return (window.theme && theme.routes && theme.routes.cart && theme.routes.cart.base) || '/cart';
  }
  function getCart() {
    return fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      });
  }

  // ---- re-randarea coșului lateral ----
  var WRAP = '.quick-cart__wrapper';
  var PARTS = ['.quick-cart__items', '.quick-cart__heading', '.quick-cart__footer-subtotal span',
    '.quick-cart__footer .quick-cart__item-discounts', '[data-cross-sells]'];
  var BAR = '[data-free-shipping-bar]';

  function sectionIdOf(sel) {
    var el = document.querySelector(sel);
    var sec = el && el.closest('[id^="shopify-section-"]');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }
  function paintBar(node) {
    if (!node) return;
    var d = node.dataset;
    var rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var thr = Math.round(parseInt(d.threshold, 10) * rate);
    var total = parseInt(d.cartTotal, 10);
    // Prag 0 = transport gratuit la toate comenzile (campania „livrare”): direct mesajul de succes.
    if (isNaN(thr) || isNaN(total)) return;
    var thrC = thr * 100;
    var msg = node.querySelector('.free-shipping-bar__message');
    var bar = node.querySelector('.free-shipping-bar__bar');
    if (total >= thrC) {
      node.dataset.isOverThreshold = true;
      if (msg) msg.innerText = d.freeShippingSuccessMessage || '';
    } else {
      node.dataset.isOverThreshold = false;
      if (msg) {
        msg.innerHTML = (d.freeShippingPendingMessage || '')
          .replace('{' + '{ remaining_amount }' + '}', '<span class="fs-body-bold">' + money(thrC - total) + '</span>');
      }
    }
    if (bar) bar.style.setProperty('--progress-width', (total < thrC ? total / thr : 100) + '%');
    node.dataset.isLoaded = true;
  }
  // Pragul de livrare gratuită în bani, din bara temei (settings.free_shipping_threshold); fără bară, null.
  function freeShippingCents() {
    var node = document.querySelector(BAR);
    var rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var thr = node ? Math.round(parseInt(node.dataset.threshold, 10) * rate) : NaN;
    return isNaN(thr) ? null : thr * 100;
  }
  function refreshDrawer() {
    var id = sectionIdOf(WRAP);
    if (!id) return Promise.resolve();
    return fetch(cartBase() + '?section_id=' + encodeURIComponent(id), { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var box = document.createElement('div');
        box.innerHTML = html;
        var old = document.querySelector(WRAP);
        var fresh = box.querySelector(WRAP);
        if (!old || !fresh) return;
        if (old.querySelector('.quick-cart__items') && fresh.querySelector('.quick-cart__items')) {
          PARTS.forEach(function (sel) {
            var n = fresh.querySelector(sel);
            var o = old.querySelector(sel);
            if (n && o) o.innerHTML = n.innerHTML;
          });
          var oldBar = old.querySelector(BAR);
          var freshBar = fresh.querySelector(BAR);
          if (oldBar && freshBar) oldBar.dataset.cartTotal = freshBar.dataset.cartTotal;
        } else {
          old.innerHTML = fresh.innerHTML;
        }
        paintBar(old.querySelector(BAR));
      });
  }
  function refreshHeader() {
    var links = document.querySelectorAll('[data-header-cart]');
    var id = links.length && sectionIdOf('[data-header-cart]');
    if (!id) return;
    fetch(cartBase() + '?section_id=' + encodeURIComponent(id), { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var box = document.createElement('div');
        box.innerHTML = html;
        var fresh = box.querySelectorAll('[data-header-cart]');
        for (var i = 0; i < links.length && i < fresh.length; i++) links[i].innerHTML = fresh[i].innerHTML;
      })
      .catch(function () {});
  }
  function syncAll(cart) {
    try { if (window.theme) window.theme.cartData = cart; } catch (err) {}
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    refreshHeader();
    return refreshDrawer();
  }
  // Pentru codurile aplicate automat (assets/tuju-auto-code.js): aceeași re-randare a coșului lateral și a header-ului.
  window.__tujuCartSync = syncAll;

  // ---- codul ACASA30 ----
  function codeApplied(cart, code) {
    return (cart.discount_codes || []).some(function (c) {
      return String(c.code).toUpperCase() === code && c.applicable;
    });
  }
  function applyCode(code) {
    return fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'),
      { cache: 'no-store', credentials: 'same-origin' })
      .catch(function () {})
      .then(getCart)
      .then(function (cart) {
        if (codeApplied(cart, code)) return cart;
        var codes = (cart.discount_codes || []).map(function (c) { return c.code; }).filter(function (c) { return String(c).toUpperCase() !== code; });
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: codes.concat([code]).join(',') })
        }).then(getCart);
      })
      .then(function (cart) {
        if (!codeApplied(cart, code)) throw { codeFailed: true };
        return cart;
      });
  }

  // ---- feedback ----
  var live;
  function announce(text) {
    if (!live) {
      live = document.createElement('p');
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'polite');
      live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 50);
  }
  function toast(text) {
    var panel = document.querySelector('.tuju-co__panel') || document.querySelector('.quick-cart__item-discounts');
    if (!panel || !text) return;
    var t = document.createElement('p');
    t.className = 'tuju-co__toast';
    t.textContent = text;
    t.style.cssText = 'margin:6px 0 0;padding:6px 10px;border-radius:8px;background:#e8f5ee;color:#0f7a3d;font-size:12.5px;font-weight:700;';
    var title = panel.querySelector('.tuju-co__title');
    if (title) title.insertAdjacentElement('afterend', t); else panel.prepend(t);
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, 4000);
  }
  function flashSubtotal() {
    var el = document.querySelector('.quick-cart__footer-subtotal');
    if (!el) return;
    el.style.transition = 'background-color .3s ease';
    el.style.backgroundColor = '#e8f5ee';
    setTimeout(function () { el.style.backgroundColor = ''; }, 600);
  }
  function scroller() {
    return document.querySelector('.quick-cart__main-content') || document.querySelector('.quick-cart__form');
  }
  function anchorTop() {
    var block = document.querySelector('[data-tuju-offers]');
    return block ? block.getBoundingClientRect().top : null;
  }
  function restoreAnchor(before) {
    var after = anchorTop();
    var sc = scroller();
    if (before !== null && after !== null && sc) sc.scrollTop += after - before;
  }
  function focusSlot(slot) {
    var btn = slot && document.querySelector('[data-tuju-offers] [data-slot="' + slot + '"] [data-tuju-offer-add]');
    if (btn) btn.focus({ preventScroll: true });
  }
  function rowError(btn, text) {
    var row = btn.closest('.tuju-co__row');
    var err = row && row.querySelector('.tuju-co__err');
    if (err) { err.textContent = text; err.hidden = false; }
    announce(text);
  }
  function errorText(err) {
    if (err && err.status === 422) return err.description || 'Nu mai avem destul stoc pentru acest produs.';
    return 'Nu s-a putut adăuga. Verifică conexiunea și încearcă din nou.';
  }

  // ---- acțiuni ----
  function addOffer(btn) {
    if (busy) return;
    busy = true;
    var kind = btn.dataset.kind;
    var slot = btn.dataset.slot;
    var code = btn.dataset.code || '';
    var title = btn.dataset.title || '';
    var label = btn.innerHTML;
    var before = anchorTop();
    var discountBefore = 0;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.innerHTML = '<span>Se adaugă…</span>';

    getCart()
      .then(function (cart) { discountBefore = cart.total_discount || 0; })
      .catch(function () {})
      .then(function () {
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] })
        });
      })
      .then(function (r) {
        return r.json().then(function (data) { if (!r.ok) throw data; });
      })
      .then(function () {
        if (!code) return getCart();
        return applyCode(code).catch(function (e) {
          if (e && e.codeFailed) {
            toast('Produsul e în coș. Codul ' + code + ' îl poți introduce la finalizarea comenzii.');
            return getCart();
          }
          throw e;
        });
      })
      .then(function (cart) {
        var delta = (cart.total_discount || 0) - discountBefore;
        var row = btn.closest('.tuju-co__row');
        if (row) row.classList.add('is-added');
        btn.innerHTML = '<span>✓ Adăugat</span>';
        var freeAt = freeShippingCents();
        var msg = title + ' a fost adăugat în coș' +
          (delta > 0 ? ' (−' + money(delta) + ')' : '') +
          (freeAt !== null && cart.total_price >= freeAt ? '. Ai livrare gratuită!' : '.');
        push({ event: 'cart_offer_add', offer_type: kind, slot: slot, variant_id: btn.dataset.variant, item_name: title,
          code_applied: codeApplied(cart, 'ACASA30'), discount_added: delta / 100, cart_value_after: cart.total_price / 100 });
        return new Promise(function (res) { setTimeout(res, 600); })
          .then(function () { return syncAll(cart); })
          .then(function () {
            restoreAnchor(before);
            focusSlot(slot);
            flashSubtotal();
            toast(msg);
            announce(msg);
          });
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.innerHTML = label;
        rowError(btn, errorText(err));
        push({ event: 'cart_offer_error', offer_type: kind, reason: err && err.status === 422 ? 'stock' : 'network' });
        // Produsul poate fi totuși în coș (ex. rețea căzută după adăugare): tema își reîmprospătează coșul.
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      })
      .then(function () { busy = false; });
  }

  function applyFromFooter(btn) {
    if (busy) return;
    busy = true;
    var code = btn.dataset.code || 'ACASA30';
    var discountBefore = 0;
    btn.disabled = true;
    btn.textContent = 'Se aplică…';
    getCart()
      .then(function (cart) { discountBefore = cart.total_discount || 0; })
      .catch(function () {})
      .then(function () { return applyCode(code); })
      .then(function (cart) {
        var delta = (cart.total_discount || 0) - discountBefore;
        push({ event: 'cart_code_apply', code: code, source: 'drawer_footer', saving: delta / 100, success: true });
        return syncAll(cart).then(function () {
          flashSubtotal();
          var msg = '✓ ' + code + ' aplicat' + (delta > 0 ? ': economisești ' + money(delta) : '') + '.';
          toast(msg);
          announce(msg);
        });
      })
      .catch(function () {
        push({ event: 'cart_code_apply', code: code, source: 'drawer_footer', success: false });
        btn.disabled = false;
        btn.textContent = 'Aplică';
        var msg = 'Codul nu s-a putut aplica aici. Introdu ' + code + ' la finalizarea comenzii.';
        toast(msg);
        announce(msg);
      })
      .then(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var add = e.target.closest('[data-tuju-offer-add]');
    if (add) {
      e.preventDefault();
      addOffer(add);
      return;
    }
    var apply = e.target.closest('[data-tuju-code-apply]');
    if (apply) {
      e.preventDefault();
      applyFromFooter(apply);
    }
  });
})();
